import AdjustButton from './AdjustButton';

type PeriodProps = {
  period: number;
  handleAddPeriod: () => void;
  handleRemovePeriod: () => void;
};

const Period = ({ period, handleAddPeriod, handleRemovePeriod }: PeriodProps) => (
  <div className="flex flex-row gap-4 items-center">
    <AdjustButton isSquare icon="minus" onClick={handleRemovePeriod} disabled={period <= 1} />
    {period || '1'}
    <AdjustButton isSquare icon="plus" onClick={handleAddPeriod} />
  </div>
);

export default Period;
